// removed by extract-text-webpack-plugin
module.exports = {"hidden":"CHiSc","visuallyhidden":"tS0qX","hide-text":"XwnAW","center":"_2Jop9","noprint":"_1LNgV","root":"_2hcZh","contentContainer":"HzV50","noA":"_3PcBe"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/theme/article/sportsfeature.scss
 ** module id = 978
 ** module chunks = 2
 **/